import React from 'react';
import { company } from '../data/company';
interface LogoProps {
  variant?: 'light' | 'dark';
}
export function Logo({
  variant = 'dark'
}: LogoProps) {
  return <img src={company.logoUrl} alt={company.name} className={`h-11 w-auto ${variant === 'light' ? 'brightness-0 invert' : ''}`} data-id="element-163" data-mp="8uwfvc7i6p44" />;
}